export default __webpack_public_path__ + "static/media/alertCircleBlack.933e4986.svg";